import { type SxProps, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material'
import type { ReactElement, ReactNode } from 'react'

import { borderStroke, colorTokens, useUiContext } from '@orus.eu/pharaoh'

type BackofficeTableProps = {
  columns?: ReactNode
  /**
   * Headers of the table, use one or more TableCellHeader components
   */
  headers: ReactNode
  /**
   * Use one or more TableRow* components
   */
  rows: ReactNode
  sx?: SxProps
}

export function BackofficeTable(props: BackofficeTableProps): ReactElement {
  const { columns, headers, rows, sx = {} } = props
  const uiContext = useUiContext()
  if (uiContext === 'mobile') {
    return (
      <TableContainer sx={{ ...sx, border: `${borderStroke[20]} solid ${colorTokens['color-stroke-base-basic']}` }}>
        <Table>
          <TableBody>{rows}</TableBody>
        </Table>
      </TableContainer>
    )
  }

  return (
    <TableContainer sx={{ ...sx, border: `${borderStroke[20]} solid ${colorTokens['color-stroke-base-basic']}` }}>
      <Table>
        {columns ? <colgroup>{columns}</colgroup> : null}
        <TableHead>
          <TableRow sx={{ borderBottom: `${borderStroke[20]} solid ${colorTokens['color-stroke-base-basic']}` }}>
            {headers}
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </Table>
    </TableContainer>
  )
}
